export default "__VITE_ASSET__CwPmK3gD__"